import React from "react";
import ReactDOM from "react-dom"
import { PayPalButtons } from "@paypal/react-paypal-js";
import { successToast, errorToast } from "../constants/ToastNotifications";
import { loaduser } from "../actions/userAction";
import { useDispatch, useSelector } from "react-redux";
import './CustomPayPalButton.css';
import axios from "axios";
//import { GetBucketAnalyticsConfigurationCommand } from "@aws-sdk/client-s3";

function PayPalPayment({ onButtonClick, closeCCPopup, ...props }) {
  const dispatch = useDispatch();
  const createOrder = (data) => {
    return axios.post("/api/auth/createpaypalorder", {
      cost: props.money,
      userid: props.userid
    }).then((response) => response.data.id)
  };
  const InEligibleError = ({ text }) => (
    <p style={{ color: "#dc3545", textTransform: "capitalize", lineHeight: '20px', margin: '0 auto' }}>
      {text || "The component is ineligible to render"}
    </p>
  );
  const onApprove = (data) => {
    if(typeof closeCCPopup == "function"){
      closeCCPopup(false);
    }
    return axios.post("/api/auth/capturepaypalorder", {
      orderID: data.orderID
    }).then((response) => {
      return response.data;
    }).then(async (data) => {
      if (data?.status == "COMPLETED") {
        const res = await axios.post("/api/auth/depositmoney", {
          price: props.money,
          userid: props.userid,
          orderid: data?.id,
          payerid: data?.payer?.payer_id,
          merchant_trans_id: data?.purchase_units[0]?.payments?.captures[0]?.id,
          payment_method: data?.payment_source?.paypal ? "PayPal" : "Venmo"
        });
        if (res) {
          await dispatch(loaduser());
          successToast("Your wallet has been credited with the money");
          props.func();
        }
      } else {
        errorToast("Transaction not successful. Something went wrong.")
      }
    })
  };

  const onError = (err) => {
    console.error('err --------------------------', err);
  };

  const onCancel = (data) => {
     if(typeof closeCCPopup == "function"){
      closeCCPopup(false);
    }
  };

  return (
    <div onClick={onButtonClick}>
      <PayPalButtons
        disabled={props.money < 0 || props.money == "" || props.money == 0}
        forceReRender={[props.money, props.userid]}
        createOrder={(data, actions) => createOrder(data, actions)}
        onApprove={(data, actions) => onApprove(data, actions)}
        style={{
          layout: 'vertical',
          color: props.paymentMethod === "creditcard" ? 'black' : props.paymentMethod === "venmo" ? 'white' : 'blue',
          shape: 'pill',
          label: 'pay',
          tagline: false
        }}
        fundingSource={
          props.paymentMethod === "venmo"
            ? "venmo"
            : props.paymentMethod === "creditcard"
              ? "card"
              : "paypal"
        }
        onError={onError}
        onClick={(data, actions) => {
          if (data.fundingSource === 'card') {
            setTimeout(() => {
              onButtonClick();
            }, 2000);
          }
        }}
        onCancel={onCancel}
      >
        <InEligibleError text={`You are not eligible to pay with ${props.paymentMethod}!`} />
      </PayPalButtons>
    </div>
  );
}

export default PayPalPayment;
